import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import ReactSlider from "react-slider";

const FlightFilter = ({
  filterData,
  FlightName,
  oneWayOrigin,
  oneWayDestination,
  returnOrigin,
  returnDestination,
  tripType,
  maxp,
  minp,
  filterTimer,
}) => {
  const [sortBy, setSortBy] = useState("");
  const [filterState, setfilterState] = useState({
    PriceSort: [],
    PriceRange: [],
    Airlines: [],
    DepatureTime: [],
    ArrivalTime: [],
    ReturnDepatureTime: [],
    ReturnArrivalTime: [],
    Reset: false,
  });

  const FilterHandler = (type, val) => {
    switch (type) {
      case "Reset":
        filterState[type] = true;
        setSortBy("");
        filterState["PriceSort"] = [];
        filterState["PriceRange"] = [];
        filterState["PriceFilter"] = [];
        filterState["PriceSort"] = [];
        filterState["PriceRange"] = [];
        filterState["Airlines"] = [];
        filterState["DepatureTime"] = [];
        filterState["ArrivalTime"] = [];
        filterState["ReturnDepatureTime"] = [];
        filterState["ReturnArrivalTime"] = [];
        setfilterState(filterState);
        filterData(filterState);
        break;

      case "PriceRange":
        clearTimeout(filterTimer);
        filterState["Reset"] = false;
        filterState["PriceRange"] = [];
        filterTimer = setTimeout(() => {
          val.map((p) => {
            filterState["PriceRange"].push(p);
          });
          setfilterState(filterState);
          filterData(filterState);
        }, 1000);

        break;

      case "PriceSort":
        setSortBy(val);
        setTimeout(() => {
          filterState["Reset"] = false;
          filterState[type] = [];
          filterState[type].push(val);
          setfilterState(filterState);
          filterData(filterState);
        }, 500);

        break;

      default:
        filterState["Reset"] = false;
        const findss = filterState[type].find((f) => f === val);

        if (findss === undefined) {
          filterState[type] = [...filterState[type], val];
        } else {
          var ind = filterState[type].findIndex((f) => f === val);
          filterState[type].splice(ind, 1);
        }
        setfilterState(filterState);
        filterData(filterState);
        break;
    }
  };
  return (
    <Fragment>
      <div aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Flight listing
          </li>
        </ol>
      </div>
      <div className="fillter-container">
      <div className={`filter-wrap`}>
        <div className="filter-title">
          <h4>Sort & Filters</h4>
          <span onClick={() => FilterHandler("Reset", "0")}>Reset</span>
        </div>

        <div className="filter-inner-wrap">
          <div className="applied-filter-wrap"></div>
        </div>
      </div>

      <div className="filter-ctr flight-filter">
        <h6 className="list-heading">Sort By</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={sortBy === "MaxToMin" ? "list active" : "list"}
              onClick={() => {
                FilterHandler("PriceSort", "MaxToMin");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/high-to-low.svg" alt="" />
              </div>
              <div className="text">High to Low</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={sortBy === "MinToMax" ? "list active" : "list"}
              onClick={() => {
                FilterHandler("PriceSort", "MinToMax");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/low-to-high.svg" alt="" />
              </div>
              <div className="text">Low to High</div>
            </div>
          </div>
        </div>
      </div>

      <div className="filter-ctr flight-filter-airlines">
        <h6 className="list-heading">Airlines</h6>
        <div className="list-items">
          {FlightName.map((name, i) => (
            <div className="list-wrapper">
              <div
                className={
                  filterState["Airlines"].includes(name)
                    ? "list active text-start"
                    : "list text-start"
                }
                onClick={() => {
                  FilterHandler("Airlines", name);
                }}
              >
                <div className="text">{name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="filter-ctr flight-filter-departureTime">
        <h6 className="list-heading">DepartureTime from {oneWayOrigin}</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["DepatureTime"].includes("0")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("DepatureTime", "0");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/sunrise.svg" alt="" />
              </div>
              <div className="text">before 6 AM</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["DepatureTime"].includes("1")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("DepatureTime", "1");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/noon.svg" alt="" />
              </div>
              <div className="text">6 to 12</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["DepatureTime"].includes("2")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("DepatureTime", "2");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/sunset.svg" alt="" />
              </div>
              <div className="text">12 to 6</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["DepatureTime"].includes("3")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("DepatureTime", "3");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/night.svg" alt="" />
              </div>
              <div className="text"> After 6</div>
            </div>
          </div>
        </div>
      </div>

      <div className="filter-ctr flight-filter-arrival">
        <h6 className="list-heading">Arrival at {oneWayDestination}</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["ArrivalTime"].includes("0")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("ArrivalTime", "0");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/sunrise.svg" alt="" />
              </div>
              <div className="text">before 6 AM</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["ArrivalTime"].includes("1")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("ArrivalTime", "1");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/noon.svg" alt="" />
              </div>
              <div className="text">6 to 12</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["ArrivalTime"].includes("2")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("ArrivalTime", "2");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/sunset.svg" alt="" />
              </div>
              <div className="text">12 to 6</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["ArrivalTime"].includes("3")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("ArrivalTime", "3");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/flight/night.svg" alt="" />
              </div>
              <div className="text"> After 6</div>
            </div>
          </div>
        </div>
      </div>

      {tripType === "2" && (
        <Fragment>
          <div className="filter-ctr flight-filter-departure">
            <h6 className="list-heading">Departure from {returnOrigin}</h6>
            <div className="list-items">
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnDepatureTime"].includes("0")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnDepatureTime", "0");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">before 6 AM</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnDepatureTime"].includes("1")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnDepatureTime", "1");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">6 to 12</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnDepatureTime"].includes("2")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnDepatureTime", "2");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">12 to 6</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnDepatureTime"].includes("3")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnDepatureTime", "3");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text"> After 6</div>
                </div>
              </div>
            </div>
          </div>

          <div className="filter-ctr flight-filter-arrival">
            <h6 className="list-heading">Arrival at {returnDestination}</h6>
            <div className="list-items">
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnArrivalTime"].includes("0")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnArrivalTime", "0");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">before 6 AM</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnArrivalTime"].includes("1")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnArrivalTime", "1");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">6 to 12</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnArrivalTime"].includes("2")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnArrivalTime", "2");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text">12 to 6</div>
                </div>
              </div>
              <div className="list-wrapper">
                <div
                  className={
                    filterState["ReturnArrivalTime"].includes("3")
                      ? "list active"
                      : "list"
                  }
                  onClick={() => {
                    FilterHandler("ReturnArrivalTime", "3");
                  }}
                >
                  <div className="filter-icons-wrap">
                    <img src="/assets/images/car-rental/petrol2.svg" alt="" />
                  </div>
                  <div className="text"> After 6</div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}

      {maxp > 0 ? (
        <div className="filter-ctr flight-filter price-range-main">
          <h6 className="list-heading">Price in $</h6>

          <ReactSlider
            className="horizontal-slider"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[minp, maxp]}
            min={parseInt(minp)}
            max={parseInt(maxp + 50)}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            onChange={([min, max]) => {
              FilterHandler("PriceRange", [min, max]);
            }}
          />
        </div>
      ) : (
        ""
      )}
      </div>
    </Fragment>
  );
};

export default FlightFilter;
